import { motion } from "framer-motion";
import { Space, Typography } from "antd";
import { FaClock, FaCalendarAlt } from "react-icons/fa";
import "./styles.css";

const { Text } = Typography;

const FlightHour = ({ date, time }) => {
  return (
    <motion.div
      className="flight-hour"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.02 }}
    >
      <Space
        direction="vertical"
        size={8}
        align="center"
        className="flight-hour-content"
      >
        <motion.div
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.2 }}
          className="time-container"
        >
          <Space align="center" size={6}>
            <FaClock className="time-icon" />
            <Text className="flight-hour-time" strong>
              {time}
            </Text>
          </Space>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="date-container"
        >
          <Space align="center" size={6}>
            <FaCalendarAlt className="date-icon" />
            <Text className="flight-hour-date" type="secondary">
              {date}
            </Text>
          </Space>
        </motion.div>
      </Space>
    </motion.div>
  );
};

export default FlightHour;
